import { render, staticRenderFns } from "./truckClassificationForm.vue?vue&type=template&id=1f8604ac&"
import script from "./truckClassificationForm.vue?vue&type=script&lang=js&"
export * from "./truckClassificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8604ac')) {
      api.createRecord('1f8604ac', component.options)
    } else {
      api.reload('1f8604ac', component.options)
    }
    module.hot.accept("./truckClassificationForm.vue?vue&type=template&id=1f8604ac&", function () {
      api.rerender('1f8604ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/truckClassificationForm.vue"
export default component.exports